import { AGENT_DETAIL_URL_SOURCE } from "./userOffer";

export interface DiagnosisPlannerLocationState {
  fromDiagnosisCompatibilityAgents?: boolean;
  searchReturnTo?: string;
  /** 遷移元の一覧（相性プランナー一覧＝診断結果・ホーム、または検索一覧）での順位（1 始まり）。詳細で上位3人だけに王冠を出すために一覧から引き継ぐ */
  compatibilityRank?: number;
}

// 同じアプリ起動中は履歴stateで追加おすすめの詳細にも導線を引き継ぐ。
// 起動時のWithAuthでは、この導線を復元せずホームへ進める。
export const isDiagnosisPlannerFlow = (location: {
  pathname: string;
  search: string;
  state?: DiagnosisPlannerLocationState;
}): boolean =>
  location.pathname.startsWith("/diagnosis_compatibility_agents/") ||
  (/^\/agent_search\/\d+\/?$/.test(location.pathname) &&
    (location.state?.fromDiagnosisCompatibilityAgents === true ||
      new URLSearchParams(location.search).get("source") === AGENT_DETAIL_URL_SOURCE.DIAGNOSIS_COMPATIBILITY_AGENTS));

/**
 * 一覧→詳細の履歴 state から順位を取り出す。
 * 1 以上の整数以外（直リンク・オファー・メッセージなど一覧を経由しない経路・壊れた値）は undefined にして王冠を出さない。
 */
export const readCompatibilityRank = (state?: DiagnosisPlannerLocationState | null): number | undefined => {
  const rank = state?.compatibilityRank;
  return typeof rank === "number" && Number.isInteger(rank) && rank > 0 ? rank : undefined;
};
